import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { BehaviorSubject, Subscription } from 'rxjs'
import { take } from 'rxjs/operators'
import { ChangeDetectorRef } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SquidexService } from '../../../../services/squidex.service'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { SEOService } from '@flowaccount/landing'
import { Meta, Title } from '@angular/platform-browser'
interface PartnerData {
  data: {
    nameUrl: {
      iv: string
    }
    nameCompany: {
      iv: string
    }
  }
}
interface PartnerInformation {
  partnerName: string
}
@Component({
  selector: 'flowaccount-find-recommend-partner-infomation',
  templateUrl: './find-recommend-partner-infomation.component.html',
  styleUrls: ['./find-recommend-partner-infomation.component.scss'],
})
export class FindRecommendPartnerInfomationComponent implements OnInit, OnDestroy {
  public ServiceList: any
  protected langChangeSubscription: Subscription
  protected subscriptionService: Subscription[] = []
  private ServiceData: BehaviorSubject<PartnerData[]> = new BehaviorSubject<PartnerData[]>([])
  private RECOMMEND_PARTNER_INFORMATION_KEY = 'recommend-partner-information-key'
  private partnerNameUrl: string
  private partnerInformation: PartnerInformation = { partnerName: '' }
  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public cdref: ChangeDetectorRef,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
    private seoService: SEOService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.partnerNameUrl = params['nameUrl']
    })
    this.langChangeSubscription = translate.onLangChange.subscribe((res) => {
      const setContent = res.lang === 'th' ? 'index' : 'noindex'
      this.meta.updateTag({ name: 'robots', content: setContent })
      this.setMeta()
    })
  }
  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate
        .useScullyTransferState(this.RECOMMEND_PARTNER_INFORMATION_KEY, this.ServiceList)
        .subscribe((data: PartnerData[]) => {
          this.ServiceData.next(data)
          this.filterPartnerNameUrl()
          this.cdref.markForCheck()
        })
    } else {
      // run every build
      this.getPartnerService()
    }
  }
  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
    this.subscriptionService.forEach((x) => x.unsubscribe())
  }

  async getPartnerService() {
    this.subscriptionService.push(
      this.squidexService
        .getContentSquidexApi('recommend-partner-infomation')
        .pipe(take(1))
        .subscribe((data: PartnerData[]) => {
          this.ServiceData.next(data)
          this.filterPartnerNameUrl()
          this.setMeta()
          this.tstate.setState(this.RECOMMEND_PARTNER_INFORMATION_KEY, data)
          this.cdref.markForCheck()
        }),
    )
  }

  protected filterPartnerNameUrl(): void {
    this.ServiceList = this.ServiceData?.value?.filter((item) => item.data.nameUrl.iv === this.partnerNameUrl) ?? []
    if (
      this.ServiceList.length === 0 &&
      this.partnerNameUrl &&
      (this.router.url.startsWith('/accountingfirm/businessowner/information/') ||
        this.router.url.startsWith('/en/accountingfirm/businessowner/information/'))
    ) {
      window.location.href = '/notfound'
    }
    this.cdref.markForCheck()
  }

  private setMeta(): void {
    const partnerName =
      this.translate.currentLang === 'th'
        ? this.ServiceList?.length > 0
          ? this.ServiceList[0]?.data?.nameCompany?.iv
          : []
        : this.partnerNameUrl.trim().charAt(0).toUpperCase() + this.partnerNameUrl.replace(/-/g, ' ').slice(1)

    this.partnerInformation = {
      partnerName: partnerName,
    }
    const metaTitle = this.translate.instant('metatitle-Accountingfirm-Information', this.partnerInformation)
    const metaDescription = this.translate.instant('metaDescription-Information', this.partnerInformation)
    this.titleService.setTitle(metaTitle)
    this.seoService.createCanonicalURL(metaDescription)
    this.seoService.createOg(
      'https://flowaccountcdn.com/new_landing/image/home/partner.jpg',
      metaTitle,
      metaDescription,
    )
  }
}
